import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="ft">
      <div className="ft__container">
        {/* ===== Top grid ===== */}
        <div className="ft__grid" role="navigation" aria-label="Footer">
          {/* 1 – Quick Links */}
          <nav className="ft__col" aria-label="Quick links">
            <h4 className="ft__heading">QUICK LINKS</h4>
            <ul className="ft__list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/moyer-blogs">Blogs</Link></li>
              <li><Link to="/moyer-projects">Projects</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>

          {/* 2 – Productions */}
          <nav className="ft__col" aria-label="Productions">
            <h4 className="ft__heading">PRODUCTIONS</h4>
            <ul className="ft__list">
              <li><Link to="/video">Video Production</Link></li>
              <li><Link to="/photography">Photography Production</Link></li>
              <li><Link to="/restaurant-marketing">Restaurant Marketing</Link></li>
            </ul>
          </nav>

          {/* 3 – Services */}
          <nav className="ft__col" aria-label="Services">
            <h4 className="ft__heading">SERVICES</h4>
            <ul className="ft__list">
              <li><Link to="/live-stream">Live Stream</Link></li>
              <li><Link to="/drone-photography">Drone Photography</Link></li>
              <li><Link to="/wedding-photography">Wedding Photography</Link></li>
              <li><Link to="/headshot">Headshot Photography</Link></li>
            </ul>
          </nav>

          {/* 4 – Connect */}
          <div className="ft__col ft__col--contact">
            <h4 className="ft__heading">CONNECT WITH US</h4>
            <address className="ft__address">
              <a href="tel:+17028824874">702-882-4874</a>
              <a href="mailto:luke@moyerproduction.com">luke@moyerproduction.com</a>
              <span>Bonney Lake, Washington</span>
            </address>

            <div className="ft__social" aria-label="Social links">
              <a
                href="https://www.instagram.com/moyerproductionco"
                aria-label="Instagram"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/MoyerEventProductionCo"
                aria-label="Facebook"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookF />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="ft__divider" />

        {/* ===== Bottom row ===== */}
        <div className="ft__legal">
          <p className="ft__copy">copyright &copy; moyerproduction Est. {year}</p>
          <div className="ft__links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span className="ft__separator">|</span>
            <Link to="/terms-conditions">Terms &amp; Conditions</Link>
            <span className="ft__separator">|</span>
            <a href="https://connectrader.com/" target="_blank" rel="noopener noreferrer">Site By connectrader</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

